import { lockBody, unlockBody } from "../../../shared/js/helpers/body-lock-toggle";
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

window.addEventListener('load', () => {
    const availableCarousels = document.querySelectorAll('.splide');
    const testimonialsSplidePanel = document.querySelectorAll('.testimonials-panel-slider');
    const promotionsPanel = document.querySelectorAll('.promotions-panel');
    const mediaPanel = document.querySelectorAll('.media-panel');
    const cardPanel = document.querySelectorAll('.card-panel-circle, .card-panel-square');
    const headerPanelFeatureHome = document.querySelectorAll('.header-panel-feature-home');
    const facadesPanel = document.querySelectorAll('.home-facade-panel');
    const homeInclusionsPanel = document.querySelectorAll('.home-inclusions-panel');
    const tradesSuppliersPanel = document.querySelectorAll('.trade-suppliers-panel');
    const promotionInclusionsPanel = document.querySelectorAll('.promotion-inclusions-panel');

    if (availableCarousels.length) {
        // START TESTIMONIAL PANEL SLIDER
        for ( const panel of testimonialsSplidePanel ) {
            const totalSlides = parseInt(panel.querySelector('.testimonials-splide').dataset.totalSlides);
            const splideCounterContainer = panel.querySelector('[data-splide-counter-container]');

            const testimonialsSplide = new Splide(panel.querySelector('.testimonials-splide'), {
                type: 'loop',
                speed: 750,
                direction: 'ltr',
                pauseOnHover: true,
                arrows: true,
                perPage: 3,
                pagination: false,
                autoplay: false,
                gap: '2rem',
                padding: '1rem',
                interval: 10000,
                destroy: totalSlides <= 3,
                classes: {
                    pagination: 'splide__pagination absolute bottom-0 left-0 w-full px-16 h-auto flex justify-center items-center gap-2 mt-14',
                    page: 'splide__pagination__page rounded-full overflow-hidden w-3 h-3 bg-gray-light-1 hover:bg-gray-light-2 [&.is-active]:!bg-gray-brand transition-all duration-150 ease-in-out',
                    arrows: 'splide__arrows absolute bottom-0 left-0 w-full h-12 flex items-center justify-between px-6 lg:px-8',
                    arrow: 'splide__arrow relative z-5 rounded-full w-12 h-12 p-4 bg-yellow-brand fill-current text-black disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 active:!duration-75 active:!scale-125 disabled:!scale-100 disabled:!opacity-20',
                    prev: 'splide__arrow--prev rotate-180',
                    next: 'splide__arrow--next',
                },
                breakpoints: {
                    1439: {
                        perPage: 3,
                        gap: '2rem',
                        padding: '2rem',
                        destroy: totalSlides <= 3,
                    },
                    1023: {
                        perPage: 2,
                        padding: '1.5rem',
                        gap: '1.5rem',
                        destroy: totalSlides <= 2,
                    },
                    767: {
                        perPage: 1,
                        padding: '1.5rem',
                        gap: '1.5rem',
                        destroy: totalSlides === 1,
                    },
                },
            });

            if (splideCounterContainer) {
                const splideCounter = splideCounterContainer.querySelector('p');

                testimonialsSplide.on('mounted move updated', function () {
                    const totalSlides = testimonialsSplide.length;
                    const perPage = testimonialsSplide.options.perPage;
                    const currentIndex = testimonialsSplide.index;

                    if (perPage === 1) {
                        splideCounter.innerHTML = (currentIndex + 1) + ' of ' + totalSlides;
                    } else {
                        const endRange = Math.min(currentIndex + perPage, totalSlides);
                        splideCounter.innerHTML = (currentIndex + 1) + '-' + endRange + ' of ' + totalSlides;
                    }
                });
            }

            // handles read more less button func on testimonials cards
            // for slider only, grid is handled with similar setup in testimonial read more / less toggle js (this requires on mounted to run properly)

            const containsReadMoreLessElements = panel.querySelector('[data-read-more-less-toggle]');

            if (containsReadMoreLessElements) {
                panel.addEventListener('click', function (event) {
                    const clickedElement = event.target;

                    if (clickedElement instanceof HTMLElement && clickedElement.hasAttribute('data-read-more-less-toggle')) {
                        clickedElement.closest('[data-read-more]').dataset.readMore = clickedElement.closest('[data-read-more]').dataset.readMore === 'true' ? 'false' : 'true';
                    }
                });

                testimonialsSplide.on('mounted', function () {
                    const handleResize = _throttle(() => {
                        const contentContainers = document.querySelectorAll('[data-read-more]');

                        if (contentContainers.length) {
                            for ( const container of contentContainers ) {
                                const proseContainer = container.querySelector('.prose');
                                const readMoreLessButton = container.querySelector('[data-read-more-less-toggle]');

                                container.dataset.readMore = 'false';

                                if (proseContainer && readMoreLessButton) {
                                    proseContainer.classList.add('!overflow-scroll');
                                    if (proseContainer.scrollHeight > proseContainer.clientHeight) {
                                        readMoreLessButton.classList.remove('hidden');
                                    }
                                    else {
                                        readMoreLessButton.classList.add('hidden');
                                    }
                                    proseContainer.classList.remove('!overflow-scroll');
                                }
                            }
                        }
                    }, 100);

                    // resets card on resize, and rechecks if a view more / less button is required.
                    handleResize();

                    window.addEventListener('resize', handleResize);
                });
            }

            testimonialsSplide.mount();
        }
        // END TESTIMONIAL PANEL SLIDER

        // START PROMOTIONS PANEL SLIDER
        for ( const panel of promotionsPanel ) {
            const totalSlides = parseInt(panel.querySelector('.promotions-splide').dataset.totalSlides);

            const promotionsSplide = new Splide(panel.querySelector('.promotions-splide'), {
                type: 'fade',
                rewind: true,
                speed: 1500,
                direction: 'ltr',
                pauseOnHover: true,
                arrows: false,
                perPage: 1,
                pagination: true,
                autoplay: true,
                interval: 7000,
                destroy: totalSlides === 1,
                classes: {
                    pagination: 'splide__pagination md:absolute bottom-8 lg:bottom-16 left-0 max-md:pb-4 px-6 lg:px-8 h-auto flex justify-center md:justify-start items-center gap-x-2 w-full md:max-w-[24rem] z-1 1.5xl:ml-[calc(50vw-45rem)]',
                    page: 'splide__pagination__page overflow-hidden w-12 h-8 hover:before:bg-gray-2 [&.is-active]:before:!bg-black-2 transition-all duration-150 ease-in-out before:content-[""] before:w-16 before:block before:bg-gray-3 before:h-0.5',
                    arrows: 'splide__arrows absolute w-full items-center justify-between flex bottom-0 mb-4',
                    arrow: 'splide__arrow relative z-5 p-0 w-4 h-4 fill-current text-black disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 active:scale-125 active:duration-75 disabled:!scale-100',
                    prev: 'splide__arrow--prev left-6 lg:left-8 rotate-180',
                    next: 'splide__arrow--next right-6 2xl:right-8',
                },
                breakpoints: {
                    1023: {
                        perPage: 1,
                    },
                    767: {
                        perPage: 1,
                    },
                },
            });

            promotionsSplide.mount();
        }
        // END PROMOTIONS PANEL SLIDER

        // START MEDIA IMAGE PANEL SLIDER
        for ( const panel of mediaPanel ) {
            const mediaImageLightbox = panel.querySelector('[data-media-image-lightbox]');
            const paginationColour = 'bg-black';
            const slideCount = panel.querySelector('.media-image-splide')?.dataset.totalSlides;
            const lightBoxSlideCount = panel.querySelector('.media-image-lightbox-splide')?.dataset.totalSlides;
            const splideCounterContainer = panel.querySelector('[data-slider="image"] [data-splide-counter-container]');

            // might not always be an image slider
            if (panel.querySelector('.media-image-splide')) {
                const mediaImageSplide = new Splide(panel.querySelector('.media-image-splide'), {
                    autoplay: false,
                    type: 'loop',
                    speed: 750,
                    gap: '1rem',
                    destroy: slideCount === '1',
                    arrows: true,
                    pagination: false,
                    classes: {
                        pagination: 'splide__pagination flex justify-center items-center gap-2 w-max h-12 mt-6 lg:mt-10 mx-auto',
                        page: 'splide__pagination__page rounded-full overflow-hidden w-3 h-3 opacity-50 hover:scale-105 [&:not(.is-active)]:bg-current [&.is-active]:opacity-100 transition-all duration-150 ease-in-out' + ' ' + paginationColour,
                        arrows: 'splide__arrows absolute bottom-0 left-0 w-full h-12 flex items-center justify-between px-6 lg:px-8 1.5xl:px-0',
                        arrow: 'splide__arrow relative z-5 rounded-full w-12 h-12 p-4 bg-yellow-brand fill-current text-black disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 active:!duration-75 active:!scale-125 disabled:!scale-100 disabled:!opacity-20',
                        prev: 'splide__arrow--prev rotate-180',
                        next: 'splide__arrow--next',
                    },
                });

                const mediaImageLightboxSplide = new Splide(panel.querySelector('.media-image-lightbox-splide'), {
                    type: 'fade',
                    speed: 750,
                    pagination: false,
                    destroy: lightBoxSlideCount === '1',
                    classes: {
                        arrows: 'splide__arrows absolute w-full h-full flex items-center justify-between',
                        arrow: 'splide__arrow relative z-5 rounded-l-lg w-14 h-16 p-2 bg-gray-900 bg-opacity-20 md:bg-transparent md:p-0 md:w-10 md:h-12 fill-current text-white disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 disabled:!scale-100',
                        prev: 'splide__arrow--prev left-0 2xl:-left-16 rotate-180',
                        next: 'splide__arrow--next right-0 2xl:-right-16',
                    },
                });

                panel.addEventListener('click', () => {
                    const clickedEventItem = event.target;

                    // Closes lightbox on backdrop/close button press
                    if (clickedEventItem.hasAttribute('data-lightbox-backdrop') || clickedEventItem.hasAttribute('data-lightbox-close')) {
                        closeLightBox();
                    }

                    // Sets lightbox slide to clicked image
                    if (clickedEventItem.hasAttribute('data-media-image') && clickedEventItem.hasAttribute('data-slide')) {
                        openLightBox();
                        mediaImageLightboxSplide.go(parseInt(clickedEventItem.dataset.slide));
                    }
                });


                function closeLightBox() {
                    mediaImageLightbox.dataset.active = 'false';
                    unlockBody();
                    setTimeout(() => {
                        mediaImageLightbox.dataset.hidden = 'true';
                    }, 300);
                }

                function openLightBox() {
                    mediaImageLightbox.dataset.hidden = 'false';
                    lockBody();
                    setTimeout(() => {
                        mediaImageLightbox.dataset.active = 'true';
                    }, 50);
                }

                if (splideCounterContainer) {
                    const splideCounter = splideCounterContainer.querySelector('p');

                    mediaImageSplide.on('mounted move', function () {
                        const totalSlides = mediaImageSplide.length;
                        const activeIndex = mediaImageSplide.index + 1;

                        splideCounter.innerHTML = activeIndex + ' of ' + totalSlides;
                    });
                }

                if (mediaImageLightbox) {
                    const progressBar = mediaImageLightbox.querySelector('[data-carousel-progress]');

                    // Updates carousel progress bar width
                    mediaImageLightboxSplide.on('mounted move', function () {
                        const end = mediaImageLightboxSplide.Components.Controller.getEnd() + 1;
                        progressBar.style.width = String(100 * (mediaImageLightboxSplide.index + 1) / end) + '%';
                    });

                    // Closes lightbox on key 'esc' press or navigates slider on keys 'arrowLeft' and 'arrowRight'
                    document.addEventListener('keydown', (e) => {
                        if (mediaImageLightbox.dataset.hidden !== 'true') {
                            if (e.key === 'Escape') {
                                closeLightBox();
                            }
                            else if (e.key === 'ArrowRight') {
                                mediaImageLightboxSplide.go('+1');
                            }
                            else if (e.key === 'ArrowLeft') {
                                mediaImageLightboxSplide.go('-1');
                            }
                        }
                    });
                }

                mediaImageLightboxSplide.mount();
                mediaImageSplide.mount()
            }
        }
        // END MEDIA IMAGE PANEL SLIDER

        // START MEDIA VIDEO PANEL SLIDER
        for ( const panel of mediaPanel ) {
            const mediaVideoLightbox = panel.querySelector('[data-media-video-lightbox]');
            const paginationColour = 'bg-black';
            const slideCount = panel.querySelector('.media-video-splide')?.dataset.totalSlides;
            const splideCounterContainer = panel.querySelector('[data-slider="video"] [data-splide-counter-container]');

            // might not always be an video slider
            if (panel.querySelector('.media-video-splide')) {
                const mediaVideoSplide = new Splide(panel.querySelector('.media-video-splide'), {
                    autoplay: false,
                    type: 'fade',
                    speed: 750,
                    gap: '1rem',
                    destroy: slideCount === '1',
                    pagination: false,
                    arrows: true,
                    classes: {
                        pagination: 'splide__pagination flex justify-center items-center gap-2 w-max h-12 mt-6 lg:mt-10 mx-auto',
                        page: 'splide__pagination__page rounded-full overflow-hidden w-3 h-3 opacity-50 hover:scale-105 [&:not(.is-active)]:bg-current [&.is-active]:opacity-100 transition-all duration-150 ease-in-out' + ' ' + paginationColour,
                        arrows: 'splide__arrows absolute bottom-0 left-0 w-full h-12 flex items-center justify-between px-6 lg:px-8 1.5xl:px-0',
                        arrow: 'splide__arrow relative z-5 rounded-full w-12 h-12 p-4 bg-yellow-brand fill-current text-black disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 active:!duration-75 active:!scale-125 disabled:!scale-100 disabled:!opacity-20',
                        prev: 'splide__arrow--prev rotate-180',
                        next: 'splide__arrow--next',
                    },
                });

                const mediaVideoLightboxSplide = new Splide(panel.querySelector('.media-video-lightbox-splide'), {
                    type: 'fade',
                    speed: 750,
                    pagination: false,
                    destroy: slideCount === '1',
                    classes: {
                        arrows: 'splide__arrows absolute w-full h-full flex items-center justify-between',
                        arrow: 'splide__arrow relative z-10 rounded-l-lg w-14 h-16 p-2 bg-gray-900 bg-opacity-20 md:bg-transparent md:p-0 md:w-10 md:h-12 fill-current text-white disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 disabled:!scale-100',
                        prev: 'splide__arrow--prev left-0 2xl:-left-16 rotate-180',
                        next: 'splide__arrow--next right-0 2xl:-right-16',
                    },
                });

                if (splideCounterContainer) {
                    const splideCounter = splideCounterContainer.querySelector('p');

                    mediaVideoSplide.on('mounted move', function () {
                        const totalSlides = mediaVideoSplide.length;
                        const activeIndex = mediaVideoSplide.index + 1;

                        splideCounter.innerHTML = activeIndex + ' of ' + totalSlides;
                    });
                }

                panel.addEventListener('click', () => {
                    const clickedEventItem = event.target;

                    // Closes lightbox on backdrop/close button press
                    if (clickedEventItem.hasAttribute('data-lightbox-backdrop') || clickedEventItem.hasAttribute('data-lightbox-close')) {
                        closeLightBox();
                    }

                    // Sets lightbox slide to clicked image
                    if (clickedEventItem.hasAttribute('data-media-video') && clickedEventItem.hasAttribute('data-slide')) {
                        openLightBox();
                        mediaVideoLightboxSplide.go(parseInt(clickedEventItem.dataset.slide));
                    }
                });

                function closeLightBox() {
                    mediaVideoLightbox.dataset.active = 'false';
                    mediaVideoLightbox.querySelectorAll('iframe,video').forEach((playerElement) => {
                        const mediaType = playerElement.getAttribute('data-media-type').toLowerCase();

                        switch (mediaType) {
                            case 'youtube':
                                playerElement.contentWindow.postMessage(
                                    JSON.stringify({
                                        event: 'command',
                                        func: 'stopVideo'
                                    }),
                                    '*'
                                );
                                break;

                            case 'vimeo':
                                playerElement.contentWindow.postMessage(
                                    JSON.stringify({
                                        method: 'pause',
                                    }),
                                    '*'
                                );
                                break;

                            case 'file':
                                playerElement.pause();
                                playerElement.currentTime = 0;
                                break;
                        }
                    });

                    unlockBody();
                    setTimeout(() => {
                        mediaVideoLightbox.dataset.hidden = 'true';
                    }, 300);
                }

                function openLightBox() {
                    mediaVideoLightbox.dataset.hidden = 'false';
                    lockBody();
                    setTimeout(() => {
                        mediaVideoLightbox.dataset.active = 'true';
                    }, 50);
                }

                if (mediaVideoLightbox) {
                    const progressBar = mediaVideoLightbox.querySelector('[data-carousel-progress]');

                    // Updates carousel progress bar width
                    mediaVideoLightboxSplide.on('mounted move', function () {
                        const end = mediaVideoLightboxSplide.Components.Controller.getEnd() + 1;
                        progressBar.style.width = String(100 * (mediaVideoLightboxSplide.index + 1) / end) + '%';
                    });

                    // Closes lightbox on key 'esc' press or navigates slider on keys 'arrowLeft' and 'arrowRight'
                    document.addEventListener('keydown', (e) => {
                        if (mediaVideoLightbox.dataset.hidden !== 'true') {
                            if (e.key === 'Escape') {
                                closeLightBox();
                            }
                            else if (e.key === 'ArrowRight') {
                                mediaVideoLightboxSplide.go('+1');
                            }
                            else if (e.key === 'ArrowLeft') {
                                mediaVideoLightboxSplide.go('-1');
                            }
                        }
                    });
                }

                mediaVideoSplide.sync(mediaVideoLightboxSplide);
                mediaVideoLightboxSplide.mount();
                mediaVideoSplide.mount()
            }

        }
        // END MEDIA VIDEO PANEL SLIDER

        // START CARD PANEL SLIDER
        for ( const panel of cardPanel ) {
            const totalSlides = parseInt(panel.querySelector('.card-panel-splide').dataset.totalSlides);
            const paginationColor = panel.querySelector('.card-panel-splide').dataset.paginationColor;

            const cardSplide = new Splide(panel.querySelector('.card-panel-splide'), {
                type: 'loop',
                speed: 750,
                direction: 'ltr',
                pauseOnHover: true,
                arrows: true,
                perPage: 3,
                pagination: true,
                autoplay: false,
                gap: '2rem',
                padding: '2rem',
                interval: 10000,
                destroy: totalSlides <= 3,
                classes: {
                    pagination: 'splide__pagination flex justify-center items-center gap-2 w-max mx-auto',
                    page: 'splide__pagination__page rounded-full overflow-hidden w-3 h-3 opacity-50 hover:scale-105 [&.is-active]:opacity-100 transition-all duration-150 ease-in-out' + ' ' + paginationColor,
                    arrows: 'splide__arrows absolute bottom-0 left-0 w-full h-12 flex items-center justify-between px-6 lg:px-8 1.5xl:px-0',
                    arrow: 'splide__arrow relative z-5 rounded-full w-12 h-12 p-4 bg-yellow-brand fill-current text-black disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 active:!duration-75 active:!scale-125 disabled:!scale-100 disabled:!opacity-20',
                    prev: 'splide__arrow--prev rotate-180',
                    next: 'splide__arrow--next',
                },
                breakpoints: {
                    1023: {
                        perPage: 2,
                        padding: '1.5rem',
                        gap: '1.5rem',
                        destroy: totalSlides <= 2,
                    },
                    767: {
                        perPage: 1,
                        padding: '1.5rem',
                        gap: '1.5rem',
                        destroy: totalSlides === 1,
                    },
                },
            });

            cardSplide.mount();
        }
        // END CARD PANEL SLIDER

        // START FEATURE HOME HEADER PANEL SLIDER
        for ( const panel of headerPanelFeatureHome ) {
            const featureImageSplideContainer = panel.querySelector('.feature-image-splide');

            if (featureImageSplideContainer) {
                const totalSlides = parseInt(panel.querySelector('.feature-image-splide').dataset.totalSlides);

                const featureImageSplide = new Splide(panel.querySelector('.feature-image-splide'), {
                    type: 'fade',
                    speed: 750,
                    rewind: true,
                    direction: 'ltr',
                    pauseOnHover: true,
                    arrows: true,
                    perPage: 1,
                    pagination: false,
                    autoplay: false,
                    interval: 7500,
                    destroy: totalSlides <= 1,
                    classes: {
                        arrows: 'splide__arrows z-5 absolute bottom-8 left-1/2 -translate-x-1/2 h-12 flex items-center justify-between w-[calc(100%-3rem)] lg:w-[calc(100%-4rem)]',
                        arrow: 'splide__arrow relative rounded-full w-12 h-12 p-4 bg-white/50 fill-current text-black disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 active:!duration-75 active:!scale-125 disabled:!scale-100 disabled:!opacity-20',
                        prev: 'splide__arrow--prev rotate-180',
                        next: 'splide__arrow--next',
                    },
                    breakpoints: {
                        1023: {
                            destroy: totalSlides <= 1,
                        },
                        767: {
                            destroy: totalSlides === 1,
                        },
                    },
                });

                featureImageSplide.mount();
            }
        }
        // END FEATURE HOME HEADER PANEL SLIDER


        // START HOME FACADE PANEL SLIDER/S
        for ( const panel of facadesPanel ) {
            const facadeCategoryPanels = panel.querySelectorAll('[data-facade-category-id]');

            if (facadeCategoryPanels.length) {
                const categoryButtons = panel.querySelectorAll('button[data-facade-category]');

                panel.addEventListener('click', (event) => {
                    const clickedElement = event.target;

                    // update active status of container corresponding to button pressed
                    if (clickedElement.hasAttribute('data-facade-category')) {
                        const newActiveCategory = clickedElement.dataset.facadeCategory;

                        for ( const categoryPanel of facadeCategoryPanels ) {
                            if (categoryPanel.dataset.facadeCategoryId === newActiveCategory) {
                                categoryPanel.dataset.active = 'true';
                            } else {
                                categoryPanel.dataset.active = 'false';
                            }
                        }

                        // update active status of all buttons
                        categoryButtons.forEach((button) => {
                            button.dataset.active = 'false';
                        });
                        clickedElement.dataset.active = 'true';
                    }
                });
            }

            for ( const facadePanel of facadeCategoryPanels ) {
                const totalSlides = parseInt(facadePanel.querySelector('.facade-splide')?.dataset.totalSlides);
                const splideCounterContainer = facadePanel.querySelector('[data-splide-counter-container]');
                const splideElement = facadePanel.querySelector('.facade-splide');

                if (splideElement !== null) {
                    const facadesSplide = new Splide(splideElement, {
                        type: 'slide',
                        speed: 750,
                        direction: 'ltr',
                        pauseOnHover: true,
                        arrows: true,
                        perPage: 1,
                        pagination: false,
                        autoplay: false,
                        gap: '2rem',
                        padding: '0',
                        interval: 10000,
                        destroy: totalSlides <= 1,
                        classes: {
                            pagination: 'splide__pagination !flex justify-center items-center gap-2 w-max h-12 mx-auto absolute bottom-0 left-1/2 -translate-x-1/2 max-w-[16rem]',
                            page: 'splide__pagination__page rounded-full overflow-hidden w-3 h-3 opacity-50 hover:scale-105 [&.is-active]:opacity-100 transition-all duration-150 ease-in-out bg-black',
                            arrows: 'splide__arrows absolute bottom-0 left-0 w-full h-12 flex items-center justify-between px-6 lg:px-8 1.5xl:px-0',
                            arrow: 'splide__arrow relative z-5 rounded-full w-12 h-12 p-4 bg-yellow-brand fill-current text-black disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 active:!duration-75 active:!scale-125 disabled:!scale-100 disabled:!opacity-20',
                            prev: 'splide__arrow--prev rotate-180',
                            next: 'splide__arrow--next',
                        },
                    });

                    if (splideCounterContainer) {
                        const splideCounter = splideCounterContainer.querySelector('p');

                        facadesSplide.on('mounted move updated', function () {
                            const totalSlides = facadesSplide.length;
                            const perPage = facadesSplide.options.perPage;
                            const currentIndex = facadesSplide.index;

                            if (perPage === 1) {
                                splideCounter.innerHTML = (currentIndex + 1) + ' of ' + totalSlides;
                            }
                            else {
                                const endRange = Math.min(currentIndex + perPage, totalSlides);
                                splideCounter.innerHTML = (currentIndex + 1) + '-' + endRange + ' of ' + totalSlides;
                            }
                        });
                    }

                    facadesSplide.mount();
                }
            }
        }
        // END HOME FACADE PANEL SLIDER/S


        // START HOME INCLUSIONS PANEL SLIDER/S
        for ( const panel of homeInclusionsPanel ) {
            const inclusionCategoryPanels = panel.querySelectorAll('[data-category-id]');
            const inclusionCategorySubtitles = panel.querySelectorAll('[data-category-subtitle-id]');
            const inclusionCategoryDownloadButtons = panel.querySelectorAll('[data-category-download-button-id]');

            if (inclusionCategoryPanels.length) {
                const categoryButtons = panel.querySelectorAll('button[data-category]');

                panel.addEventListener('click', (event) => {
                    const clickedElement = event.target;

                    // update active status of container corresponding to button pressed
                    if (clickedElement.hasAttribute('data-category')) {
                        const newActiveCategory = clickedElement.dataset.category;

                        for ( const categoryPanel of inclusionCategoryPanels ) {
                            if (categoryPanel.dataset.categoryId === newActiveCategory) {
                                categoryPanel.dataset.active = 'true';
                            }
                            else {
                                categoryPanel.dataset.active = 'false';
                            }
                        }

                        for ( const categorySubtitle of inclusionCategorySubtitles ) {
                            if (categorySubtitle.dataset.categorySubtitleId === newActiveCategory) {
                                categorySubtitle.dataset.active = 'true';
                            }
                            else {
                                categorySubtitle.dataset.active = 'false';
                            }
                        }

                        for ( const categoryDownloadButton of inclusionCategoryDownloadButtons ) {
                            if (categoryDownloadButton.dataset.categoryDownloadButtonId === newActiveCategory) {
                                categoryDownloadButton.dataset.active = 'true';
                            }
                            else {
                                categoryDownloadButton.dataset.active = 'false';
                            }
                        }

                        // update active status all buttons
                        categoryButtons.forEach((button) => {
                            button.dataset.active = 'false';
                        });
                        clickedElement.dataset.active = 'true';
                    }
                });
            }

            for ( const categoryPanel of inclusionCategoryPanels ) {
                const totalSlides = parseInt(categoryPanel.querySelector('.inclusion-splide').dataset.totalSlides);
                const splideCounterContainer = categoryPanel.querySelector('[data-splide-counter-container]');

                const inclusionsSplide = new Splide(categoryPanel.querySelector('.inclusion-splide'), {
                    type: 'slide',
                    speed: 750,
                    direction: 'ltr',
                    pauseOnHover: true,
                    arrows: true,
                    perPage: 3,
                    pagination: false,
                    autoplay: false,
                    gap: '2rem',
                    padding: '0',
                    interval: 10000,
                    destroy: totalSlides <= 3,
                    classes: {
                        pagination: 'splide__pagination !flex justify-center items-center gap-2 w-max h-12 mx-auto absolute bottom-0 left-1/2 -translate-x-1/2 max-w-[16rem]',
                        page: 'splide__pagination__page rounded-full overflow-hidden w-3 h-3 opacity-50 hover:scale-105 [&.is-active]:opacity-100 transition-all duration-150 ease-in-out bg-black',
                        arrows: 'splide__arrows absolute bottom-0 left-0 w-full h-12 flex items-center justify-between px-6 lg:px-8 1.5xl:px-0',
                        arrow: 'splide__arrow relative z-5 rounded-full w-12 h-12 p-4 bg-yellow-brand fill-current text-black disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 active:!duration-75 active:!scale-125 disabled:!scale-100 disabled:!opacity-20',
                        prev: 'splide__arrow--prev rotate-180',
                        next: 'splide__arrow--next',
                    },
                    breakpoints: {
                        1439: {
                            perPage: 3,
                            padding: '2rem',
                            gap: '2rem',
                            destroy: totalSlides <= 3,
                        },
                        1023: {
                            perPage: 2,
                            padding: '1.5rem',
                            gap: '1.5rem',
                            destroy: totalSlides <= 2,
                        },
                        767: {
                            perPage: 1,
                            padding: '1.5rem',
                            gap: '1.5rem',
                            destroy: totalSlides === 1,
                        },
                    },
                });

                if (splideCounterContainer) {
                    const splideCounter = splideCounterContainer.querySelector('p');

                    inclusionsSplide.on('mounted move updated', function () {
                        const totalSlides = inclusionsSplide.length;
                        const perPage = inclusionsSplide.options.perPage;
                        const currentIndex = inclusionsSplide.index;

                        if (perPage === 1) {
                            splideCounter.innerHTML = (currentIndex + 1) + ' of ' + totalSlides;
                        } else {
                            const endRange = Math.min(currentIndex + perPage, totalSlides);
                            splideCounter.innerHTML = (currentIndex + 1) + '-' + endRange + ' of ' + totalSlides;
                        }
                    });
                }

                inclusionsSplide.mount();
            }
        }
        // END HOME INCLUSIONS PANEL SLIDER/S

        // START TELETHON TRADES SUPPLIER PANEL SLIDER/S
        for ( const panel of tradesSuppliersPanel ) {
            const totalSlides = parseInt(panel.querySelector('.trade-suppliers-splide').dataset.totalSlides);

            const tradeSupplierSplide = new Splide(panel.querySelector('.trade-suppliers-splide'), {
                type: 'loop',
                speed: 750,
                direction: 'ltr',
                pauseOnHover: true,
                pagination: false,
                arrows: true,
                perPage: 5,
                gap: '.5rem',
                padding: '0',
                destroy: totalSlides <= 5,
                autoScroll: {
                    speed: 1,
                },
                classes: {
                    arrows: 'splide__arrows w-full h-12 flex items-center justify-between order-last absolute top-1/2 -translate-y-1/2 z-2 pointer-events-none',
                    arrow: 'splide__arrow relative z-5 rounded-full w-12 h-12 p-4 pointer-events-auto bg-yellow-brand fill-current text-black disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 active:!duration-75 active:!scale-125 disabled:!scale-100 disabled:!opacity-20',
                    prev: 'splide__arrow--prev rotate-180 -left-16',
                    next: 'splide__arrow--next -right-16',
                },
                breakpoints: {
                    1439: {
                        perPage: 4,
                        padding: '2rem',
                        gap: '.5rem',
                        destroy: totalSlides <= 4,
                    },
                    1279: {
                        perPage: 4,
                        padding: '2rem',
                        gap: '.5rem',
                        destroy: totalSlides <= 4,
                    },
                    1023: {
                        perPage: 3,
                        padding: '1.5rem',
                        gap: '.5rem',
                        destroy: totalSlides <= 3,
                    },
                    767: {
                        perPage: 2,
                        padding: '1.5rem',
                        gap: '.5rem',
                        destroy: totalSlides === 2,
                    },
                    467: {
                        perPage: 1,
                        padding: '1.5rem',
                        gap: '.5rem',
                        destroy: totalSlides === 1,
                    },
                },
            });

            tradeSupplierSplide.mount({ AutoScroll });
        }
        // END TELETHON TRADES SUPPLIER PANEL SLIDER/S

        // START PROMOTION INCLUSIONS PANEL SLIDER
        for ( const panel of promotionInclusionsPanel ) {
            const totalSlides = parseInt(panel.querySelector('.promotion-inclusion-splide').dataset.totalSlides);
            const splideCounterContainer = panel.querySelector('[data-splide-counter-container]');

            const promotionInclusionSplide = new Splide(panel.querySelector('.promotion-inclusion-splide'), {
                type: 'loop',
                speed: 750,
                direction: 'ltr',
                pauseOnHover: true,
                arrows: true,
                perPage: 3,
                pagination: false,
                autoplay: false,
                gap: '2rem',
                padding: '0',
                interval: 10000,
                destroy: totalSlides <= 3,
                classes: {
                    pagination: 'splide__pagination !flex justify-center items-center gap-2 w-max h-12 mx-auto absolute bottom-0 left-1/2 -translate-x-1/2 max-w-[16rem]',
                    page: 'splide__pagination__page rounded-full overflow-hidden w-3 h-3 opacity-50 hover:scale-105 [&.is-active]:opacity-100 transition-all duration-150 ease-in-out bg-black',
                    arrows: 'splide__arrows absolute bottom-0 left-0 w-full h-12 flex items-center justify-between px-6 lg:px-8 1.5xl:px-0',
                    arrow: 'splide__arrow relative z-5 rounded-full w-12 h-12 p-4 bg-yellow-brand fill-current text-black disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 active:!duration-75 active:!scale-125 disabled:!scale-100 disabled:!opacity-20',
                    prev: 'splide__arrow--prev rotate-180',
                    next: 'splide__arrow--next',
                },
                breakpoints: {
                    1439: {
                        perPage: 3,
                        padding: '2rem',
                        gap: '2rem',
                        destroy: totalSlides <= 3,
                    },
                    1023: {
                        perPage: 2,
                        padding: '1.5rem',
                        gap: '1.5rem',
                        destroy: totalSlides <= 2,
                    },
                    767: {
                        perPage: 1,
                        padding: '1.5rem',
                        gap: '1.5rem',
                        destroy: totalSlides === 1,
                    },
                },
            });

            if (splideCounterContainer) {
                const splideCounter = splideCounterContainer.querySelector('p');

                promotionInclusionSplide.on('mounted move updated', function () {
                    const totalSlides = promotionInclusionSplide.length;
                    const perPage = promotionInclusionSplide.options.perPage;
                    const currentIndex = promotionInclusionSplide.index;

                    if (perPage === 1) {
                        splideCounter.innerHTML = (currentIndex + 1) + ' of ' + totalSlides;
                    } else {
                        const endRange = Math.min(currentIndex + perPage, totalSlides);
                        splideCounter.innerHTML = (currentIndex + 1) + '-' + endRange + ' of ' + totalSlides;
                    }
                });
            }

            promotionInclusionSplide.mount();
        }
        // END PROMOTION INCLUSIONS PANEL SLIDER
    }
});